// CX design system: tokens (light + dark via prefers-color-scheme), the opt-in
// `.cx-base` layer and every component style ship in one stylesheet. CX does
// not bundle Inter (its body font), so we load it here. The static package is
// used on purpose: CX tokens name the family "Inter", which the variable
// package ("Inter Variable") would not match. Weights = the CX type ramp.
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/700.css";
import "@fontsource/manrope/700.css";
import "@prophero-ds/cx-react/styles.css";
import "./design-system.css";

/** Class that applies CX typography and surface colours to its subtree. */
export const CX_BASE_CLASS = "cx-base";
